<template>
  <div class="content-wrapper">
    <div class="welcome-page-container">
      <WelcomeIcons />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import WelcomeIcons from "redbay-b2b-categories/src/CategoriesIconsWelcome.vue";
import { ContactForm, BannerOpacity } from "../RedbayComponents";
import BrandsIcons from "redbay-b2b-brands/src/BrandCarousel.vue";
import WelcomeModal from "./WelcomeModal.vue";
export default {
  name: "WelcomePage",
  components: {
    WelcomeIcons,
    BannerOpacity,
    ContactForm,
    BrandsIcons,
    WelcomeModal
  },
  beforeMount() {
    if (!this.$store.state.user.authorizedUser) {
      this.$router.replace({ name: "mainPage" });
    }
    if (!this.$config.get("welcomePage.enabled")) {
      this.$router.replace({ name: "searchPage" });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/template/WelcomePage.vue